/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { DocPageModel } from "app/client/models/DocPageModel";
import { testId } from "app/client/ui2018/cssVars";
import { tokens } from "app/common/ThemePrefs";

import { dom, MultiHolder, Observable, styled } from "grainjs";

export function createBottomBarDoc(owner: MultiHolder, pageModel: DocPageModel, leftPanelOpen: Observable<boolean>,
  rightPanelOpen: Observable<boolean>) {
  return dom.maybe(pageModel.gristDoc, gristDoc => (
    cssPageName(
      dom.text(gristDoc.currentPageName),
      dom.on("click", () => { rightPanelOpen.set(false); leftPanelOpen.set(true); }),
      testId("page-name"),
    )
  ));
}

const cssPageName = styled("div", `
  color: ${tokens.body};
  margin: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`);
